import React from 'react';
import styled from 'styled-components';
import { TextareaAutosize, TextareaAutosizeProps } from '@material-ui/core';

export const Textarea = styled(
  React.forwardRef<HTMLTextAreaElement, TextareaAutosizeProps & { error?: boolean }>(
    ({ error, minRows = 5, ...restProps }, ref) => (
      <TextareaAutosize minRows={minRows} {...restProps} ref={ref} />
    )
  )
)`
  background: ${({ theme }) => theme.palette.common.white};
  border: ${({ theme }) => theme.config.defaultBorder()};
  border-radius: ${({ theme }) => theme.config.defaultBorderRadius};
  resize: vertical;
  padding: ${({ theme }) => theme.spacing(0.5, 2)};
  font-size: ${({ theme }) => theme.typography.h3.fontSize};
  font-family: ${({ theme }) => theme.config.primaryFontFamily};
  color: ${({ theme }) => theme.palette.grey['900']};
  width: 100%;
  ${({ error }) =>
    error &&
    `
    border-bottom: 0.2rem solid #f00;
  `}

  &:hover {
    border-bottom: 2px solid #000;
  }
  &:focus {
    outline: none;
    border-bottom: 2px solid ${({ theme }) => theme.palette.primary.main};
  }
`;
